<template>
  <div class="home-echarts-wrap" :style="{ width, height, marginBottom }">
    <div class="home-echarts-header" style="padding: 10px 24px 0 24px;height: auto">
      <h3 class="home-echarts-header__title">{{ title }}</h3>
    </div>
    <!-- 延迟显示 loading 效果。当 spinning 状态在 delay 时间内结束，则不显示 loading 状态。 -->
    <a-spin :spinning="spinning" :delay="200">
      <!-- echarts 图表 -->
      <div ref="chartRef" class="home-echarts-content" v-show="showECharts"></div>
    </a-spin>
  </div>
</template>

<script setup lang="ts">
import type { PropType, Ref } from 'vue'
import { onMounted, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'

const props = defineProps({
  title: {
    type: String as PropType<string>,
    default: ''
  },
  value: {
    type: Object as PropType<Object>
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '171px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '0px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
})
watch(() => props.value, (val) => {
  getData()
})
onMounted(() => {
  getData()
})
const spinning = ref(false)
const showECharts = ref(false)
const getData = () => {
  spinning.value = false
  showECharts.value = true
  initChart()
  // spinning.value = false
  // getNewActivatedCustomerMonthlyRevenue(queryForm).then((res) => {
  //   const salesAmountList = res.data?.salesAmountList as unknown as ItemCommonType[]
  //   const activatedCustomerMonthlyRevenueList = transChartData(salesAmountList)
  //   if (activatedCustomerMonthlyRevenueList.length) {
  //     showECharts.value = true
  //     initChart(activatedCustomerMonthlyRevenueList)
  //   } else {
  //     showECharts.value = false
  //     initChart([])
  //   }
  // }).finally(() => {
  //   spinning.value = false
  // })
}

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, true)
const initChart = () => {
  setOptions({
    // 悬浮窗
    tooltip: {
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: 'White'
      },
      formatter: function (params) {
        const toolsTipsResult = []
        /// 这里需要用括号包裹，否则会先走0 + ‘</strong>’
        toolsTipsResult.push('目标值  <strong>' + (props?.value?.targetValue ?? 0) + '</strong>')
        toolsTipsResult.push('完成值  <strong>' + (props?.value?.completeValue ?? 0) + '</strong>')
        toolsTipsResult.push('完成率  <strong>' + ((props?.value?.rateValue ?? 0) + '%') + '</strong>')
        return toolsTipsResult.join('<br>')
      }
    },
    series: [
      // 灰色背景层
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        radius: '100%',
        center: ['50%', '75%'],
        progress: {
          show: true,
          width: 14,
          roundCap: true,
          itemStyle: {
            color: '#eee'
          }
        },
        axisLine: {
          lineStyle: {
            width: 14,
            color: [[1, '#eee']]
          }
        },
        pointer: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        detail: {
          show: false
        },
        data: [
          {
            value: 100
          }
        ],
        z: 1 // 背景层在下面
      },

      // 橙色进度层
      {
        type: 'gauge',
        startAngle: 180,
        endAngle: 0,
        radius: '100%',
        center: ['50%', '75%'],
        progress: {
          show: true,
          width: 14,
          roundCap: true,
          itemStyle: {
            color: '#f90'
          }
        },
        axisLine: {
          lineStyle: {
            width: 14,
            color: [[(props?.value?.rateValue ?? 0) / 100, '#f90'], [1, 'transparent']]
          }
        },
        pointer: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        detail: {
          valueAnimation: true,
          fontSize: 18,
          fontWeight: 'bold',
          formatter: '{value} %',
          offsetCenter: [0, '-30%'],
          color: '#333'
        },
        data: [
          {
            value: props?.value?.rateValue ?? 0
          }
        ],
        z: 2 // 进度层在上面
      }
    ]
  })
}
</script>
<script lang="ts">
export default {
  name: 'RegionRevenueManagementGauge'
}
</script>
<style scoped lang="scss">

</style>
